/**
 * Format a user's display string for lock-related UI.
 * Returns format: "{firstName lastName} ({email})" or just name/email if only one exists.
 * Returns "another user" if no data available.
 */
export function formatUserDisplay(
  user: { firstName?: string; lastName?: string; email?: string } | null,
): string {
  if (!user) return "another user";

  const name = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  if (name && user.email) return `${name} (${user.email})`;
  if (name) return name;
  if (user.email) return user.email;
  return "another user";
}
